'use client'
import {Container, Nav} from "react-bootstrap";
import styles from "./header.module.scss";
import {NavLink} from "../../libs/navlink/NavLink";
import {Logo} from "../../libs/logo/Logo";

export default function Header() {
    const headerMenu = [
        {name: "Our Why", href: "/#our-why"},
        {name: "User Journey", href: "/#user-journey"},
        {name: "Your Business", href: "/#business"},
        {name: "PUP Rewards", href: "/#rewards"},
        {name: "Contact Us", href: "/contact-us"},
        {name: "Shop", href: "https://shop.getpup.pro/"},
    ];

    return (
        <Container 
            fluid={"xxl"}
            className={`flex flex-row align-items-center justify-content-between flex-xs-column gap-3 ${styles.header}`}
        >
            <Logo/>
            <Nav className={"align-items-center justify-content-center gap-2"}>
                {
                    headerMenu.map(menuItem => (
                        <NavLink key={menuItem.href} href={menuItem.href}>{menuItem.name}</NavLink>
                    ))
                }
            </Nav>
        </Container>
    );
}
